import {Alert, Form, Input} from "antd";
import _ from "lodash";
import React from "react";
import MultilanguageInput from "../../components/multilanguage-input";
import {MARGIN_MD, SPAN_ONE_THIRD, SPAN_TWO_THIRDS} from "../../styles/constants";
import {compose} from "redux";
import {translate} from 'react-i18next';

const mapPropsToFields = ({category}) => ({
  catCode: Form.createFormField({
    value:
      (category !== null && category.catCode !== undefined)
        ? category.catCode
        : null
  }),
  labels: Form.createFormField({
    value:
      (category !== null && category.labels !== undefined)
        ? category.labels
        : null
  })
});

const onFieldsChange = ({onChange}, fields) => {
  onChange(_.mapValues(fields, ({value}) => value));
};

const formItemLayout = {
  labelCol: {span: SPAN_ONE_THIRD},
  wrapperCol: {span: SPAN_TWO_THIRDS}
};

const CategoryForm = ({
                        form,
                        t
                      }) =>
  <Form className="advanced-form">
    <Alert
      type="info"
      showIcon
      message={t("middlewares.defaultCategorySchemeSelector.createModal.infoMessage")}
      style={{marginBottom: MARGIN_MD}}
    />
    <Form.Item
      className="form-item-required"
      label={t("data.item.id.label")}
      {...formItemLayout}
    >
      {form.getFieldDecorator("catCode", {
        getValueFromEvent: e => e.target.value.toUpperCase()
      })(
        <Input
          title={form.getFieldValue("catCode")}
          style={{textTransform: "uppercase"}}
        />
      )}
    </Form.Item>
    <Form.Item
      className={"form-item-required"}
      label={t("data.item.name.label")}
      {...formItemLayout}
    >
      {form.getFieldDecorator("labels")(
        <MultilanguageInput
          title={form.getFieldValue("labels")}
        />
      )}
    </Form.Item>
  </Form>;

export default compose(
  translate(),
  Form.create({mapPropsToFields, onFieldsChange})
)(CategoryForm);


// WEBPACK FOOTER //
// ./src/middlewares/default-category-scheme-selector/CategoryForm.jsx